import jQuery from "jquery";
import { HOT_DATA_BUSINESSES } from "../data/constants";
import { SETTINGS } from "../settings";

const $ = jQuery;

const serviceUrl = SETTINGS.totalApiUrl;
const hotDataUrl = SETTINGS.hotDataUrl;
let token;
let retry = true;

const getToken = function getToken(callback) {
    $.ajax({
        url: "https://totalms.webgeoservices.com/maps/data/token/",
        success: function success(response) {
            token = response.access_token;
            callback();
        },
    });
};

const get = function get(storeId, callback) {
    const getPrice = () => {
        const url = ""
            .concat(
                serviceUrl,
                "?Lang=fr_FR&AdditionalData=Items&AdditionalDataFields=Items_Code,Items_Price,Items_Availability,Items_UpdateDate&Code=",
            )
            .concat(storeId);
        $.ajax({
            url,
            headers: {
                Authorization: token,
            },
            success: function success(response) {
                const data = {};
                let requMessage;
                retry = true;

                if (response.Pois?.length) {
                    // handle the items
                    if (response.Pois[0].Items) {
                        for (const item of response.Pois[0].Items) {
                            data[item.Code.toLowerCase()] = {
                                price: item.Price,
                                available: item.Availability,
                                currency: response.Pois[0].Currency,
                            };

                            if (item.UpdateDate) {
                                data[item.Code.toLowerCase()].updateDate = item.UpdateDate.replace("T", " ");
                            }
                        }
                    } // handle the requisition message

                    if (response.Pois[0].RequMessage && response.Pois[0].RequMessage !== "") {
                        requMessage = response.Pois[0].RequMessage;
                    }
                }
                callback(data, requMessage);
            },
            error: function error(response) {
                if (response.status === 401 && retry) {
                    retry = false;
                    getToken(() => {
                        getPrice();
                    });
                } else {
                    retry = true;
                    callback();
                    console.log("No price data found for the storeId ".concat(storeId));
                }
            },
        });
    };

    if (!token) {
        getToken(() => {
            getPrice();
        });
    } else {
        getPrice();
    }
};
// TO DO: REVISIT LATER
const getHotData = function getHotData(locationId, callback, business) {
    const headersAllowed = new Headers();
    headersAllowed.append("Accept", "application/json");
    headersAllowed.append("API-Key", SETTINGS.totalKey);
    const requestOptions = {
        method: "GET",
        headers: headersAllowed,
    };
    let url = `${hotDataUrl}location_id=${locationId}&type=FUELING`;
    if (HOT_DATA_BUSINESSES.includes(business)) {
        url += `&business_type=${business.toUpperCase()}`;
    }
    fetch(url, requestOptions)
        .then((response) => response.json())
        .then((response) => {
            if (response?.products_and_services) {
                callback(response.products_and_services);
            } else {
                callback(null);
            }
        })
        .catch((error) => {
            console.error(error);
            callback(null);
        });
};
const priceService = {
    get,
    getHotData,
};
export default priceService;
